import React, { useEffect, useState } from 'react'
import Format from './Format'

const EmailsToClipBoardInstallation = (props) => {
    const [user, setUser] = useState({})
    const { form, selectedSpare , spareConf} = props

    useEffect(() => {
        let u = localStorage.getItem('user');
        if (u) {
            u = JSON.parse(u);
            setUser(u);
        }
    }, [])


    return (
        <div>
            <Format data={{ form, selectedSpare, user, spareConf }} />
        </div>
    )
}

export default EmailsToClipBoardInstallation


